import { render, staticRenderFns } from "./AmbientiPlanimetrie.vue?vue&type=template&id=4731ef54&"
import script from "./AmbientiPlanimetrie.vue?vue&type=script&lang=js&"
export * from "./AmbientiPlanimetrie.vue?vue&type=script&lang=js&"
import style0 from "./AmbientiPlanimetrie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports